export default {
	name: "indexView",
	data() {
		return {
			typeList: [{
				name: "课程",
				value: "1"
			}, {
				name: "优作",
				value: "2"
			}, {
				name: "专栏",
				value: "3"
			}],
			selIndex: 0,
			collectList: []
		};
	},
	watch: {},
	async mounted() {
		await this.getCollectionList();
	},
	onUpdated() {},
	beforeDestroy() {},
	methods: {
		async onStatusChange(index) {
			this.selIndex = parseInt(index);
			await this.getCollectionList();
		},
		async getCollectionList() {
			const collectionRes = await this.$zkHttp.user$getCollection({
				user_id: this.$store.state.auth.user_id,
				type_list: this.typeList[this.selIndex].value, //1=课程,2=优作,3--专栏
				page: 1,
				limit: 100
			});
			console.log("collectionRes ===> ", collectionRes);
			this.collectList = collectionRes;
		},
		toCourseDetail(co) {
			this.$router.push({
				name: 'courseDetail',
				query: {
					parent: 'home',
					course_id: co.course_id
				}
			});
		},
		toMyPage(page) {
			this.$router.push(`/${page}`);
		},
	},
};